
import { forwardRef } from "react";

const SortAscendingIcon = forwardRef(({
    ...props
}, ref) => {
    return (
        <svg className={`svg-regular`} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
            <rect width="24" height="24" rx="5" fill="white" fillOpacity="0.01" />
            <path d="M6 10.4421L12 4L18 10.4421H6Z" fill="#A2AEB6" />
            <path d="M6 13.9778L12 20.4199L18 13.9778H6Z" fill="#0060A8" />
        </svg>
    );
});

export default SortAscendingIcon;
